(function () {
  'use strict';

  var drawer;
  var activeProduct;
  var selectedOptions = [];
  var isLoading = false;
  var productCache = {};

  function money(cents) {
    if (window.theme && theme.Currency) return theme.Currency.formatMoney(cents, theme.settings.moneyFormat);
    return '$' + (cents / 100).toFixed(2);
  }

  function escapeHtml(value) {
    return String(value || '').replace(/[&<>'"]/g, function (character) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;' }[character];
    });
  }

  function getVariant() {
    return activeProduct.variants.find(function (variant) {
      return variant.options.every(function (option, index) {
        return selectedOptions[index] === option;
      });
    });
  }

  function isOptionAvailable(optionIndex, value) {
    return activeProduct.variants.some(function (variant) {
      return variant.available && variant.options.every(function (option, index) {
        return index === optionIndex ? option === value : !selectedOptions[index] || selectedOptions[index] === option;
      });
    });
  }

  function renderOptions() {
    var variant = getVariant();
    var html = activeProduct.options.map(function (optionName, optionIndex) {
      var label = typeof optionName === 'object' ? (optionName.name || optionName.value || '') : optionName;
      var rawValues = activeProduct.options_with_values ? activeProduct.options_with_values[optionIndex].values : Array.from(new Set(activeProduct.variants.map(function (variant) { return variant.options[optionIndex]; })));
      var values = rawValues.map(function (value) { return typeof value === 'object' ? (value.value || value.name || '') : value; });
      return '<fieldset class="dv-quick-add__option"><legend>' + escapeHtml(label) + '</legend><div class="dv-quick-add__values">' + values.map(function (value) {
        var selected = selectedOptions[optionIndex] === value;
        var available = isOptionAvailable(optionIndex, value);
        return '<button type="button" class="dv-quick-add__value' + (selected ? ' is-selected' : '') + '" data-dv-option-index="' + optionIndex + '" data-dv-option-value="' + escapeHtml(value) + '"' + (available ? '' : ' disabled aria-disabled="true"') + '>' + escapeHtml(value) + '</button>';
      }).join('') + '</div></fieldset>';
    }).join('');

    drawer.querySelector('[data-dv-options]').innerHTML = html;
    drawer.querySelector('[data-dv-price]').textContent = money((variant || activeProduct.variants[0]).price);
    var addButton = drawer.querySelector('[data-dv-add]');
    var ready = variant && variant.available;
    addButton.disabled = !ready;
    addButton.textContent = ready ? 'Add to cart' : (variant ? 'Sold out' : 'Select options');
    var image = drawer.querySelector('[data-dv-image]');
    var imageUrl = variant && variant.featured_image ? variant.featured_image.src : activeProduct.featured_image;
    // Same variant image; Shopify CDN returns only the compact size needed by Quick Add.
    if (imageUrl) imageUrl += (imageUrl.indexOf('?') === -1 ? '?' : '&') + 'width=360';
    image.src = imageUrl || '';
    image.alt = activeProduct.title;
  }

  function closeDrawer() {
    drawer.classList.remove('is-open');
    document.documentElement.classList.remove('dv-quick-add-open');
  }

  function openDrawer(product) {
    activeProduct = product;
    selectedOptions = product.variants[0].options.slice();
    drawer.querySelector('[data-dv-title]').textContent = product.title;
    drawer.querySelector('[data-dv-details]').href = product.url;
    drawer.classList.add('is-open');
    document.documentElement.classList.add('dv-quick-add-open');
    renderOptions();
  }

  function openLoadingDrawer() {
    drawer.querySelector('[data-dv-title]').textContent = 'Loading product';
    drawer.querySelector('[data-dv-price]').textContent = '';
    drawer.querySelector('[data-dv-image]').src = '';
    drawer.querySelector('[data-dv-options]').innerHTML = '';
    drawer.querySelector('[data-dv-error]').textContent = '';
    drawer.querySelector('[data-dv-add]').disabled = true;
    drawer.querySelector('[data-dv-add]').textContent = 'Loading…';
    drawer.classList.add('is-open');
    document.documentElement.classList.add('dv-quick-add-open');
  }

  function openProduct(handle) {
    openLoadingDrawer();
    fetchProduct(handle).then(openDrawer).catch(function () {
      closeDrawer();
      window.location.href = '/products/' + handle;
    });
  }

  function addToCart() {
    var variant = getVariant();
    if (!variant || !variant.available || isLoading) return;
    isLoading = true;
    var button = drawer.querySelector('[data-dv-add]');
    button.classList.add('btn--loading');
    fetch((window.theme && theme.routes ? theme.routes.cartAdd : '/cart/add.js'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: [{ id: variant.id, quantity: 1 }] })
    }).then(function (response) { return response.json(); }).then(function (result) {
      if (result.status === 422) throw new Error(result.description || result.message);
      document.dispatchEvent(new CustomEvent('cart:build'));
      document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: result } }));
      // Match the theme's standard add-to-cart flow: release Quick Add, then open Cart Drawer.
      // Opening in the next frame lets Impulse apply its existing drawer state without a page flash.
      closeDrawer();
      window.setTimeout(function () {
        // Open the same Impulse Cart Drawer used by the normal product form.
        document.dispatchEvent(new CustomEvent('cart:open'));
      }, 50);
    }).catch(function (error) {
      var errorBox = drawer.querySelector('[data-dv-error]');
      errorBox.textContent = error.message || 'Unable to add this item. Please try again.';
    }).finally(function () {
      isLoading = false;
      button.classList.remove('btn--loading');
    });
  }

  function fetchProduct(handle) {
    if (productCache[handle]) return productCache[handle];
    productCache[handle] = fetch('/products/' + encodeURIComponent(handle) + '.js').then(function (response) {
      if (!response.ok) throw new Error('Unable to load this product.');
      return response.json();
    });
    productCache[handle].catch(function () { delete productCache[handle]; });
    return productCache[handle];
  }

  function injectTriggers(scope) {
    (scope || document).querySelectorAll('.grid-product[data-product-handle]').forEach(function (card) {
      if (card.querySelector('.dv-quick-add-trigger')) return;
      var trigger = document.createElement('button');
      trigger.type = 'button';
      trigger.className = 'dv-quick-add-trigger';
      trigger.setAttribute('aria-label', 'Quick add ' + card.dataset.productHandle);
      trigger.setAttribute('data-dv-quick-add-trigger', '');
      trigger.innerHTML = '<svg class="dv-quick-add-trigger__icon" viewBox="0 0 24 24" aria-hidden="true"><path d="M6 8h12l-1 11H7L6 8Z" fill="none" stroke="currentColor" stroke-width="1.8"/><path d="M9 9V6a3 3 0 0 1 6 0v3" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/><path d="M10 13h.01M14 13h.01" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"/></svg><span class="visually-hidden">Quick add</span>';
      var target = card.querySelector('.grid-product__image-mask') || card.querySelector('.grid__item-image-wrapper') || card.querySelector('.grid-product__content') || card;
      target.appendChild(trigger);
    });
  }

  function init() {
    drawer = document.createElement('aside');
    drawer.className = 'dv-quick-add';
    drawer.setAttribute('aria-label', 'Quick add product');
    drawer.innerHTML = '<div class="dv-quick-add__backdrop" data-dv-close></div><div class="dv-quick-add__panel" role="dialog" aria-modal="true"><button type="button" class="dv-quick-add__close" data-dv-close aria-label="Close">&times;</button><div class="dv-quick-add__product"><img data-dv-image><div><h2 data-dv-title></h2><p class="dv-quick-add__price" data-dv-price></p></div></div><div data-dv-options></div><p class="dv-quick-add__error" data-dv-error></p><button type="button" class="btn dv-quick-add__submit" data-dv-add>Add to cart</button><a class="dv-quick-add__details" data-dv-details>View full details</a></div>';
    document.body.appendChild(drawer);

    // Capture card clicks before Impulse's grid-link navigation handler runs.
    injectTriggers();
    new MutationObserver(function (records) {
      records.forEach(function (record) {
        record.addedNodes.forEach(function (node) {
          if (node.nodeType === 1) injectTriggers(node);
        });
      });
    }).observe(document.body, { childList: true, subtree: true });

    document.addEventListener('click', function (event) {
      var close = event.target.closest('[data-dv-close]');
      if (close) { closeDrawer(); return; }
      var option = event.target.closest('[data-dv-option-index]');
      if (option && !option.disabled) {
        selectedOptions[Number(option.dataset.dvOptionIndex)] = option.dataset.dvOptionValue;
        renderOptions();
        return;
      }
      if (event.target.closest('[data-dv-add]')) { addToCart(); return; }
      var externalTrigger = event.target.closest('[data-dv-quick-add-handle]');
      if (externalTrigger) {
        event.preventDefault();
        event.stopPropagation();
        openProduct(externalTrigger.dataset.dvQuickAddHandle);
        return;
      }
      var trigger = event.target.closest('[data-dv-quick-add-trigger]');
      if (trigger) {
        event.preventDefault();
        event.stopPropagation();
        var triggerCard = trigger.closest('.grid-product[data-product-handle]');
        if (triggerCard) openProduct(triggerCard.dataset.productHandle);
        return;
      }
      var card = event.target.closest('.grid-product[data-product-handle]');
      if (!card || event.target.closest('.quick-product__btn, .js-modal-open-quick-modal, .dv-quick-add__details')) return;
      if (!event.target.closest('a.grid-product__link')) return;
      return;
    }, true);

    document.addEventListener('pointerover', function (event) {
      var trigger = event.target.closest('[data-dv-quick-add-handle]');
      if (trigger) fetchProduct(trigger.dataset.dvQuickAddHandle);
    }, { passive: true });

    document.addEventListener('keydown', function (event) { if (event.key === 'Escape') closeDrawer(); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
}());
